import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=e340c404"
import script from "./PageIndex.vue?vue&type=script&lang=js"
export * from "./PageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports